import { Helper } from '../../../js/util/helper';

export default class Header {
  constructor( node ) {
    this.node = node;
    this.toggleButton = node.querySelector( '.js-header-toggle' );
    this.searchToggleButtons = [ ...node.querySelectorAll( '.js-header-search-toggle' ) ];
    this.searchForm = node.querySelector( '.js-header-search-form' );
    this.searchInput = node.querySelector( '.js-header-search-input' );
    this.searchInputLabel = node.querySelector( '.header__search-input-label' );
    this.searchSubmit = node.querySelector( '.js-header-search-submit' );
    this.searchAutoSuggest = node.querySelector( '.header__search-autosuggest-container' );
    this.searchReset = node.querySelector( '.header__search-reset' );
    this.headerTop = node.querySelector( '.header__top' );
    this.headerContent = node.querySelector( '.header__content' );
    this.firstScrollPosition = 0;
    this.lastScrollPosition = 0;
    this.scrollLength = 0;
    this.scrollDirection = null;
    this.addEventListener();
    this.initSearch();
    this.handleFocus();
  }
  addEventListener() {
    this.toggleButton.addEventListener( 'click', () => {
      this.node.classList.toggle( 'header--hidden-content' );
      this.setHeaderContentMaxHeight();
    });
    this.searchToggleButtons.forEach(( button ) => {
      button.addEventListener( 'click', this.toggleSearch.bind( this ));
    });
    this.searchSubmit.addEventListener( 'click', () => {
      this.searchForm.submit();
    });
    this.searchReset.addEventListener( 'click', () => {
      this.searchInput.value = '';
      this.searchInput.setAttribute( 'value', '' );
    });
    this.searchForm.addEventListener( 'click', ( event ) => {
      if ( this.searchForm === event.target ) {
        this.toggleSearch();
      }
    });
    document.body.addEventListener( 'open-header-flyout', () => {
      this.searchForm.classList.remove( 'header__search-form--open' );
      this.node.querySelector( '.header__search-button' ).classList.remove( 'header__search-button--active' );
    });
    // wait for complete to prevent scroll events by page load
    document.onreadystatechange = () => {
      if ( document.readyState == 'complete' ) {
        this.setStickyHeader();
        this.initScrollEvent();
      }
    };
    window.addEventListener( 'resize', Helper.debounce(() => {
      this.setStickyHeader();
      this.setHeaderContentMaxHeight();
    }, 250 ));

    this.node.addEventListener( 'transitionend', function( event ) {
      if ( event.propertyName === 'padding-top' ) {
        document.body.dispatchEvent( new CustomEvent( 'header-transition-end' ));
      }
    }, false );
  }
  // iOS bug: https://stackoverflow.com/a/37113430
  setHeaderContentMaxHeight() {
    let headerTopHeight = this.headerTop.getBoundingClientRect().height;
    let maxHeight = window.innerHeight - headerTopHeight;

    if ( window.innerWidth < 1023 ) {
      if ( this.node.classList.contains( 'header--hidden-content' )) {
        this.headerContent.style.maxHeight = 0;
      } else {
        this.headerContent.style.maxHeight = maxHeight + 'px';
      }
    } else {
      this.headerContent.style.maxHeight = 'none';
    }

  }
  toggleSearch() {
    this.searchForm.classList.toggle( 'header__search-form--open' );
    if ( this.searchForm.classList.contains( 'header__search-form--open' )) {
      this.searchInput.focus();
      document.body.dispatchEvent( new CustomEvent( 'open-search' ));
    }
    this.node.querySelector( '.header__search-button' ).classList.toggle( 'header__search-button--active' );
    if ( window.innerWidth < 1024 ) {
      this.setHeaderContentMaxHeight();
    }
  }
  setStickyHeader() {
    let height = this.node.getBoundingClientRect().height;
    let main = document.querySelector( 'main' );
    if ( main ) {
     // main.style.paddingTop = height + 'px';
    }
    this.node.style.position = 'sticky';
    this.checkForDrupal();
  }
  initScrollEvent() {
    setTimeout(() => {
      this.firstScrollPosition = window.pageYOffset;
      this.lastScrollPosition = window.pageYOffset;
      window.addEventListener( 'scroll', this.handleScrollEvent.bind( this ));
    }, 250 );
  }
  handleScrollEvent( event ) {
    let scrollPosition = window.pageYOffset;
    let scrollDirection = scrollPosition > this.lastScrollPosition ? 'down' : 'up';

    // scroll direction has changed
    if ( this.scrollDirection && this.scrollDirection !== scrollDirection ) {
      this.scrollLength = 0;
      this.firstScrollPosition = scrollPosition;
    } else {
      this.scrollLength = scrollPosition - this.firstScrollPosition;
    }

    this.scrollDirection = scrollDirection;
    this.lastScrollPosition = window.pageYOffset;
    this.toggleSickyHeader( this.scrollLength );
  }
  toggleSickyHeader( scrollLength ) {
    if ( scrollLength > 100 && !this.node.classList.contains( 'header--sticky' )) {
      this.node.classList.add( 'header--sticky' );
      document.body.dispatchEvent( new CustomEvent( 'header-transition-start' ));
    } else if ( scrollLength < -100 && this.node.classList.contains( 'header--sticky' )) {
      this.node.classList.remove( 'header--sticky' );
      document.body.dispatchEvent( new CustomEvent( 'header-transition-start' ));
    }
  }
  initSearch() {
    this.searchInput.onfocus = function() {
      if ( !this.searchInputLabel.classList.contains( 'header__search-input-label--active' )) {
        this.searchInputLabel.classList.add( 'header__search-input-label--active' );
      }
    }.bind( this );

    this.searchInput.onblur = function() {
      if ( this.searchInputLabel.classList.contains( 'header__search-input-label--active' ) && this.searchInput.value === '' ) {
        this.searchInputLabel.classList.remove( 'header__search-input-label--active' );
      }
    }.bind( this );

    this.searchInput.addEventListener( 'input', ( e ) => {
      let input = e.target.value;
      e.target.setAttribute( 'value', input );
      if ( input.length >= 3 ) {
        this.requestAutoSuggest( input );
      } else if ( input.length < 3 && this.searchAutoSuggest.classList.contains( 'header__search-autosuggest-container--active' )) {
        this.searchAutoSuggest.classList.remove( 'header__search-autosuggest-container--active' );
        this.searchAutoSuggest.children[ 0 ].innerHTML = '';
      }
    });
  }
  requestAutoSuggest( input ) {
    let xmlhttp = new XMLHttpRequest();

    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
      if ( xmlhttp.readyState === 4 && xmlhttp.status === 200 ) {
        let response = xmlhttp.responseText;
        let json = JSON.parse( response.replace( /<\/?[^>]+>/gi, '' ));
        this.fillAutoSuggest( json, input );
      }
    }.bind( this );
    xmlhttp.open( 'GET', `search_api_autocomplete/search?display=search_page&filter=query&q=${ input }`, true );
    xmlhttp.send();

    this.fillAutoSuggest([ { value: 'slider' }, { value: 'slide' }, { value: 'slider container' }, { value: 'slider machine' }, { value: 'slideshow' }, { value: 'sliderview' }, { value: 'slider' }, { value: 'slider' } ], input );
  }
  fillAutoSuggest( data, input ) {
    let result = '';

    if ( data.length > 0 ) {
      for ( let string of data ) {
        let temp = string.value.split( input );
        if ( temp.length > 1 ) {
          let html = this.createResultAsHtml( temp, input );
          result = result +
            `<li class="header__search-autosuggest-item" data-input="${string.value}">
                <span class="header__search-autosuggest-result">${ html }</span>
             </li>`;
        }
      }
      if ( result !== '' ) {
        this.searchAutoSuggest.children[ 0 ].innerHTML = result;
        this.autoSuggestClickEvent();
        if ( !this.searchAutoSuggest.classList.contains( 'header__search-autosuggest-container--active' )) {
          this.searchAutoSuggest.classList.add( 'header__search-autosuggest-container--active' );
        }
      }
    }
  }
  createResultAsHtml( array, input ) {
    let result = '';
    for ( let i = 0; i < array.length; i++ ) {
      if ( array[ i ] === '' && i === 0 ) {
        result = result +
          '<span class="header__search-autosuggest-result header__search-autosuggest-input">' + input + '</span>';
      } else if ( i !== array.length - 1 ) {
        result = result + array[ i ] +
          '<span class="header__search-autosuggest-result header__search-autosuggest-input">' + input + '</span>';
      } else {
        result = result + array[ i ];
      }
    }
    return result;
  }
  autoSuggestClickEvent() {
    let items = document.querySelectorAll( '.header__search-autosuggest-item' );
    let search = this.node.querySelector( '#header-search-input' );

    for ( let item of items ) {
      item.addEventListener( 'click', () => {
        search.value = item.getAttribute( 'data-input' );
        document.getElementById( 'header-search-submit' ).click();
      });
      item.onkeydown = function( e ) {
        if ( e.keyCode === 13 || e.keyCode === 32 ) {
          search.value = item.getAttribute( 'data-input' );
          document.getElementById( 'search-search-submit' ).click();
        }
      };
    }
  }
  handleFocus() {
    this.searchInput.onfocus = function() {
      document.onkeydown = function( e ) {
        setTimeout( function() {
          let itemsContainer = this.searchAutoSuggest.querySelector( '.header__search-autosuggest-items' );

          if ( itemsContainer.children.length > 1 ) {
            let active = this.searchAutoSuggest.querySelector( '.header__search-autosuggest-item--active' );

            if ( active === null && ( e.keyCode === 40 || e.keyCode === 38 )) {
              itemsContainer.children[ 0 ].classList.add( 'header__search-autosuggest-item--active' );
            } else if ( active !== null && e.keyCode === 40 ) {
              for ( let i = 0; i < itemsContainer.children.length; i++ ) {
                if ( itemsContainer.children[ i ].classList.contains( 'header__search-autosuggest-item--active' ) && i !== itemsContainer.children.length - 1 ) {
                  active.classList.remove( 'header__search-autosuggest-item--active' );
                  itemsContainer.children[ i + 1 ].classList.add( 'header__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ i + 1 ].offsetHeight * ( i + 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                } else if ( itemsContainer.children[ i ].classList.contains( 'header__search-autosuggest-item--active' ) && i === itemsContainer.children.length - 1 ) {
                  active.classList.remove( 'header__search-autosuggest-item--active' );
                  itemsContainer.children[ 0 ].classList.add( 'header__search-autosuggest-item--active' );
                  let toScroll = 0;
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                }
              }
            } else if ( active !== null && e.keyCode === 38 ) {
              for ( let i = 0; i < itemsContainer.children.length; i++ ) {
                if ( itemsContainer.children[ i ].classList.contains( 'header__search-autosuggest-item--active' ) && i !== 0 ) {
                  active.classList.remove( 'header__search-autosuggest-item--active' );
                  itemsContainer.children[ i - 1 ].classList.add( 'header__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ i - 1 ].offsetHeight * ( i - 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                } else if ( itemsContainer.children[ i ].classList.contains( 'header__search-autosuggest-item--active' ) && i === 0 ) {
                  active.classList.remove( 'header__search-autosuggest-item--active' );
                  itemsContainer.children[ itemsContainer.children.length - 1 ].classList.add( 'header__search-autosuggest-item--active' );
                  let toScroll = itemsContainer.children[ itemsContainer.children.length - 1 ].offsetHeight * ( itemsContainer.children.length - 1 );
                  this.searchAutoSuggest.scrollTo({ top: toScroll, behavior: 'smooth' });
                  break;
                }
              }
            } else if ( active !== null && ( e.keyCode === 13 || e.keyCode === 32 )) {
              let search = this.node.querySelector( '#header-search-input' );
              search.value = active.getAttribute( 'data-input' );
              document.getElementById( 'header-search-submit' ).click();
            }
          }
        }.bind( this ), 0 );
      }.bind( this );
    }.bind( this );
  }
  checkForDrupal() {
    let bodyPadding = document.body.style.paddingTop;

    if ( bodyPadding !== '' ) {
      this.node.style.marginTop = bodyPadding;
    }
  }
}

